export default "__VITE_ASSET__C7i$R6mG__"